import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useBaseUrl } from "../Contexts/BaseUrlContext";

const TABS = [["stats", "Overview"], ["users", "Users"], ["blogs", "Blogs"], ["posters", "Posters"], ["comments", "Comments"], ["payments", "Payments"], ["contacts", "Messages"]];
const PLAN = { D1: "1 Day", W7: "7 Days", M30: "30 Days", M90: "90 Days", Y365: "365 Days" };
const fd = (s) => (s ? new Date(s).toLocaleString("en-IN") : "");
const th = "px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500";
const td = "px-3 py-2 text-sm border-t align-top";
const btn = (c) => "px-3 py-1.5 rounded text-white text-sm mr-2 mb-1 " + c;
const Badge = ({ t, c }) => <span className={"px-2 py-0.5 rounded-full text-xs text-white " + c}>{t}</span>;
const MON = { NONE: ["—", "bg-gray-400"], REQUESTED: ["Requested", "bg-amber-500"], APPROVED: ["Approved", "bg-green-600"], REJECTED: ["Rejected", "bg-red-600"] };

export default function Website() {
  const { baseUrl } = useBaseUrl();
  const [tab, setTab] = useState("stats");
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [mon, setMon] = useState("");
  const [data, setData] = useState(null);
  const [sel, setSel] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [detail, setDetail] = useState(null);
  const [grant, setGrant] = useState({ email: "", plan: "W7", note: "" });

  const call = useCallback(async (payload) => {
    const f = new FormData();
    f.append("payload", JSON.stringify(payload));
    const r = await axios.post(`${baseUrl}/website.php`, f, { withCredentials: true });
    if (!r.data.status) throw new Error(r.data.error || "Failed");
    if (r.data.data && r.data.data.error) throw new Error(r.data.data.error);
    return r.data.data;
  }, [baseUrl]);

  const load = useCallback(async () => {
    setBusy(true); setMsg("");
    try {
      const p = { action: tab, q, take: 50 };
      if (tab === "blogs") { if (status) p.status = status; if (mon) p.monetization = mon; }
      if (tab === "payments") p.status = status || "PENDING";
      if (tab === "contacts") p.status = status || "NEW";
      setData(await call(p)); setSel([]);
    } catch (e) { setMsg(e.message); setData(null); }
    setBusy(false);
  }, [tab, q, status, mon, call]);

  useEffect(() => { load(); }, [tab, status, mon]); // eslint-disable-line

  async function act(payload, ask, after) {
    if (ask && !window.confirm(ask)) return;
    try { const r = await call(payload); if (after) after(r); else load(); setMsg(""); } catch (e) { setMsg(e.message); }
  }
  async function openUser(id) {
    try { setDetail(await call({ action: "userDetail", id })); } catch (e) { setMsg(e.message); }
  }
  const tog = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const ask = (t, d) => window.prompt(t, d);
  const switchTab = (k) => { setTab(k); setQ(""); setStatus(""); setMon(""); setDetail(null); };

  return (
    <div className="m-2 md:m-10 mt-24 p-4 md:p-8 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <h1 className="text-2xl font-bold">Website Control</h1>
      <p className="text-sm text-gray-500">ycnp.in वेबसाइट का पूरा डेटा यहाँ से देखें और संभालें</p>

      <div className="flex flex-wrap gap-2 mt-4">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => switchTab(k)} className={"px-4 py-1.5 rounded-full text-sm border " + (tab === k ? "bg-cyan-600 text-white" : "")}>{l}</button>
        ))}
      </div>

      <div className="flex flex-wrap gap-2 mt-4 items-center">
        {["users", "blogs", "posters", "comments", "payments"].includes(tab) && (
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder={tab === "payments" ? "UTR / name / email" : "Search…"} className="border rounded px-3 py-1.5 text-sm" />
        )}
        {tab === "blogs" && (
          <>
            <select value={status} onChange={(e) => setStatus(e.target.value)} className="border rounded px-2 py-1.5 text-sm">
              <option value="">All status</option>{["PUBLISHED", "DRAFT", "PRIVATE", "UNLISTED"].map((s) => <option key={s}>{s}</option>)}
            </select>
            <select value={mon} onChange={(e) => setMon(e.target.value)} className="border rounded px-2 py-1.5 text-sm">
              <option value="">All monetization</option>{["REQUESTED", "APPROVED", "REJECTED", "NONE"].map((s) => <option key={s}>{s}</option>)}
            </select>
          </>
        )}
        {tab === "payments" && (
          <select value={status || "PENDING"} onChange={(e) => setStatus(e.target.value)} className="border rounded px-2 py-1.5 text-sm">
            {["PENDING", "APPROVED", "REJECTED", "ALL"].map((s) => <option key={s}>{s}</option>)}
          </select>
        )}
        {tab === "contacts" && (
          <select value={status || "NEW"} onChange={(e) => setStatus(e.target.value)} className="border rounded px-2 py-1.5 text-sm">
            {["NEW", "SEEN", "REPLIED", "CLOSED", "ALL"].map((s) => <option key={s}>{s}</option>)}
          </select>
        )}
        {tab !== "stats" && <button onClick={load} className={btn("bg-cyan-600")}>Search / Refresh</button>}
      </div>

      {busy && <p className="mt-4 text-gray-500">Loading…</p>}
      {msg && <p className="mt-4 text-red-600 text-sm">{msg}</p>}

      {/* ===== OVERVIEW ===== */}
      {data && tab === "stats" && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          {Object.entries({ Users: data.users, "Blocked users": data.blockedUsers, Blogs: data.blogs, Published: data.published, Posters: data.posters, Comments: data.comments, Likes: data.likes, Views: data.views, "Pending payments": data.pendingPayments, "Revenue (Rs)": data.revenue, "Monetization requests": data.monetRequests, "Monetization approved": data.monetApproved, "New messages": data.newMessages }).map(([k, v]) => (
            <div key={k} className="border rounded-2xl p-4"><p className="text-xs text-gray-500">{k}</p><p className="text-2xl font-bold">{v}</p></div>
          ))}
        </div>
      )}

      {/* ===== USERS ===== */}
      {data && tab === "users" && !detail && (
        <table className="w-full mt-4"><thead><tr><th className={th}>Name</th><th className={th}>Email</th><th className={th}>Blogs</th><th className={th}>Posters</th><th className={th}>Comments</th><th className={th}>Likes</th><th className={th}>Joined</th><th className={th}></th></tr></thead>
          <tbody>{data.items.map((u) => (
            <tr key={u.id}>
              <td className={td}>{u.name} {u.blocked && <Badge t="Blocked" c="bg-red-600" />}</td><td className={td}>{u.email}</td>
              <td className={td}>{u.blogs}</td><td className={td}>{u.posters}</td><td className={td}>{u.comments}</td><td className={td}>{u.likes}</td><td className={td}>{fd(u.at)}</td>
              <td className={td}>
                <button className={btn("bg-cyan-600")} onClick={() => openUser(u.id)}>Activity</button>
                <button className={btn(u.blocked ? "bg-green-600" : "bg-amber-600")} onClick={() => act({ action: "userBlock", id: u.id, blocked: !u.blocked }, (u.blocked ? "Unblock" : "Block") + " this user?")}>{u.blocked ? "Unblock" : "Block"}</button>
                <button className={btn("bg-red-600")} onClick={() => act({ action: "userDelete", id: u.id }, "इस यूज़र और उसका सारा डेटा हमेशा के लिए हटाएँ?")}>Delete</button>
              </td>
            </tr>))}</tbody></table>
      )}
      {detail && tab === "users" && (
        <div className="mt-4">
          <button className={btn("bg-gray-600")} onClick={() => setDetail(null)}>‹ Back</button>
          <h2 className="text-xl font-bold mt-2">{detail.name} {detail.blocked && <Badge t="Blocked" c="bg-red-600" />}</h2>
          <p className="text-sm text-gray-500">{detail.email} · Joined {fd(detail.at)} · Likes given {detail.likes}</p>
          {detail.bio && <p className="text-sm mt-1">{detail.bio}</p>}
          <h3 className="font-bold mt-4">Blogs ({detail.blogs.length})</h3>
          <table className="w-full"><tbody>{detail.blogs.map((b) => (<tr key={b.id}><td className={td}>{b.title}</td><td className={td}>{b.status}</td><td className={td}>{b.views} views</td><td className={td}><Badge t={MON[b.monetization][0]} c={MON[b.monetization][1]} /></td></tr>))}</tbody></table>
          <h3 className="font-bold mt-4">Posters ({detail.posters.length})</h3>
          <table className="w-full"><tbody>{detail.posters.map((p) => (<tr key={p.id}><td className={td}>{p.title}</td><td className={td}>{p.views} views</td></tr>))}</tbody></table>
          <h3 className="font-bold mt-4">Recent comments</h3>
          <table className="w-full"><tbody>{detail.comments.map((c) => (<tr key={c.id}><td className={td}>{c.text}</td><td className={td}>on {c.post}</td><td className={td}>{fd(c.at)}</td></tr>))}</tbody></table>
          <h3 className="font-bold mt-4">Payments</h3>
          <table className="w-full"><tbody>{detail.payments.map((p) => (<tr key={p.id}><td className={td}>{PLAN[p.plan] || p.plan}</td><td className={td}>Rs {p.amount}</td><td className={td}>{p.utr}</td><td className={td}>{p.status}</td><td className={td}>{fd(p.expiresAt)}</td></tr>))}</tbody></table>
        </div>
      )}

      {/* ===== BLOGS ===== */}
      {data && tab === "blogs" && (
        <>
          {sel.length > 0 && (
            <div className="mt-4 p-3 border rounded-xl">
              <b className="mr-3">{sel.length} selected</b>
              <button className={btn("bg-green-600")} onClick={() => act({ action: "blogStatus", ids: sel, status: "PUBLISHED" })}>Publish</button>
              <button className={btn("bg-gray-600")} onClick={() => act({ action: "blogStatus", ids: sel, status: "DRAFT" })}>Draft</button>
              <button className={btn("bg-pink-600")} onClick={() => act({ action: "blogStatus", ids: sel, status: "PRIVATE" })}>Private</button>
              <button className={btn("bg-green-700")} onClick={() => act({ action: "monetize", ids: sel, value: "APPROVED" }, "Monetization approve करें?")}>Approve monetization</button>
              <button className={btn("bg-orange-600")} onClick={() => { const n = ask("Reject का कारण:", "Traffic या quality कम है"); if (n !== null) act({ action: "monetize", ids: sel, value: "REJECTED", note: n }); }}>Reject monetization</button>
              <button className={btn("bg-red-600")} onClick={() => act({ action: "blogDelete", ids: sel }, "Delete " + sel.length + " blogs permanently?")}>Delete</button>
            </div>
          )}
          <p className="text-xs text-gray-500 mt-3">Total: {data.total}</p>
          <table className="w-full mt-1"><thead><tr><th className={th}></th><th className={th}>Title</th><th className={th}>Author</th><th className={th}>Status</th><th className={th}>Views</th><th className={th}>Likes</th><th className={th}>Comments</th><th className={th}>Monetization</th></tr></thead>
            <tbody>{data.items.map((b) => (
              <tr key={b.id}>
                <td className={td}><input type="checkbox" checked={sel.includes(b.id)} onChange={() => tog(b.id)} /></td>
                <td className={td}><a href={`https://ycnp.in/blogs/${b.slug}`} target="_blank" rel="noreferrer" className="text-cyan-700">{b.title}</a></td>
                <td className={td}>{b.author}</td><td className={td}>{b.status}</td><td className={td}>{b.views}</td><td className={td}>{b.likes}</td><td className={td}>{b.comments}</td>
                <td className={td}><Badge t={MON[b.monetization][0]} c={MON[b.monetization][1]} />{b.monetNote && <p className="text-xs text-gray-500">{b.monetNote}</p>}</td>
              </tr>))}</tbody></table>
        </>
      )}

      {/* ===== POSTERS ===== */}
      {data && tab === "posters" && (
        <table className="w-full mt-4"><thead><tr><th className={th}>Poster</th><th className={th}>Author</th><th className={th}>Views</th><th className={th}>Likes</th><th className={th}></th></tr></thead>
          <tbody>{data.items.map((p) => (<tr key={p.id}><td className={td}><img src={p.image} alt="" className="h-12 w-12 object-cover rounded inline mr-2" /><a href={`https://ycnp.in/posters/${p.slug}`} target="_blank" rel="noreferrer" className="text-cyan-700">{p.title}</a></td><td className={td}>{p.author}</td><td className={td}>{p.views}</td><td className={td}>{p.likes}</td><td className={td}><button className={btn("bg-red-600")} onClick={() => act({ action: "posterDelete", ids: [p.id] }, "Delete this poster?")}>Delete</button></td></tr>))}</tbody></table>
      )}

      {/* ===== COMMENTS ===== */}
      {data && tab === "comments" && (
        <table className="w-full mt-4"><thead><tr><th className={th}>Comment</th><th className={th}>By</th><th className={th}>On post</th><th className={th}>Date</th><th className={th}></th></tr></thead>
          <tbody>{data.items.map((c) => (<tr key={c.id}><td className={td}>{c.text}</td><td className={td}>{c.by}</td><td className={td}>{c.post}</td><td className={td}>{fd(c.at)}</td><td className={td}><button className={btn("bg-red-600")} onClick={() => act({ action: "commentDelete", id: c.id }, "Delete comment?")}>Delete</button></td></tr>))}</tbody></table>
      )}

      {/* ===== PAYMENTS ===== */}
      {tab === "payments" && (
        <div className="mt-4 p-3 border rounded-xl">
          <b className="text-sm">किसी को हाथ से प्लान दें</b>
          <div className="flex flex-wrap gap-2 mt-2">
            <input value={grant.email} onChange={(e) => setGrant({ ...grant, email: e.target.value })} placeholder="user email" className="border rounded px-3 py-1.5 text-sm" />
            <select value={grant.plan} onChange={(e) => setGrant({ ...grant, plan: e.target.value })} className="border rounded px-2 text-sm">{Object.entries(PLAN).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
            <input value={grant.note} onChange={(e) => setGrant({ ...grant, note: e.target.value })} placeholder="कारण (optional)" className="border rounded px-3 py-1.5 text-sm" />
            <button className={btn("bg-green-600")} onClick={() => act({ action: "payGrant", ...grant }, "यह प्लान इस यूज़र को दें?", () => { setGrant({ email: "", plan: "W7", note: "" }); load(); })}>Give plan</button>
          </div>
        </div>
      )}
      {data && tab === "payments" && (
        <div className="mt-4 space-y-3">
          {data.items.length === 0 && <p className="text-gray-500">कोई request नहीं।</p>}
          {data.items.map((p) => (
            <div key={p.id} className="border rounded-2xl p-4 flex flex-wrap gap-4">
              {p.screenshot !== "/manual" && <a href={p.screenshot} target="_blank" rel="noreferrer"><img src={p.screenshot} alt="" className="h-32 w-24 object-cover rounded" /></a>}
              <div className="flex-1 text-sm min-w-[220px]">
                <p><b>{p.name}</b> · {p.email}</p>
                <p>Plan <b>{PLAN[p.plan] || p.plan}</b> · Rs <b>{p.amount}</b> · UTR <b>{p.utr}</b></p>
                <p className="text-gray-500">{fd(p.at)} · {p.status}{p.until ? " · चालू " + fd(p.until) + " तक" : ""}{p.note ? " · " + p.note : ""}</p>
                <button className="text-cyan-700 text-xs mt-1" onClick={() => { switchTab("users"); setQ(p.email || ""); setTimeout(() => openUser(p.userId), 50); }}>Profile / activity देखें</button>
              </div>
              {p.status === "PENDING" && (
                <div>
                  <button className={btn("bg-green-600")} onClick={() => { if (window.confirm("पहले बैंक में UTR और रकम मिला ली? Approve करें?")) act({ action: "payReview", id: p.id, decision: "approve" }); }}>Approve</button>
                  <button className={btn("bg-red-600")} onClick={() => { const n = ask("Reject का कारण (यूज़र को दिखेगा):", "UTR गलत है या पेमेंट नहीं मिला"); if (n !== null) act({ action: "payReview", id: p.id, decision: "reject", note: n }); }}>Reject</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ===== MESSAGES ===== */}
      {data && tab === "contacts" && (
        <div className="mt-4 space-y-3">
          {data.items.length === 0 && <p className="text-gray-500">कोई संदेश नहीं।</p>}
          {data.items.map((m) => (
            <div key={m.id} className="border rounded-2xl p-4 text-sm">
              <p><b>{m.name}</b> · {m.email} · <span className="text-gray-500">{fd(m.createdAt)}</span> · <Badge t={m.status} c="bg-cyan-600" /></p>
              {m.subject && <p className="font-semibold mt-1">{m.subject}</p>}
              <p className="mt-1 whitespace-pre-wrap">{m.message}</p>
              {m.reply && <p className="mt-2 p-2 bg-gray-100 rounded">आपका नोट: {m.reply}</p>}
              <div className="mt-2">
                <button className={btn("bg-gray-600")} onClick={() => act({ action: "contactUpdate", id: m.id, status: "SEEN" })}>Seen</button>
                <button className={btn("bg-green-600")} onClick={() => { const r = ask("जवाब / नोट:", m.reply || ""); if (r !== null) act({ action: "contactUpdate", id: m.id, status: "REPLIED", reply: r }); }}>Reply note</button>
                {m.email && <a className={btn("bg-cyan-600") + " inline-block"} href={"mailto:" + m.email + "?subject=Re: " + (m.subject || "YCNP")}>Email भेजें</a>}
                <button className={btn("bg-orange-600")} onClick={() => act({ action: "contactUpdate", id: m.id, status: "CLOSED" })}>Close</button>
                <button className={btn("bg-red-600")} onClick={() => act({ action: "contactDelete", id: m.id }, "Delete message?")}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}